export enum LogEventType {
  CYBER = "cyber",
  DEVICE = "device", // LPP4
  DEVICE_FLEET = "device_fleet", // legacy DVTM log events
  SYSTEM = "system",
}
